import { translate } from "app/filters/i18nFilter";
import { COMPANY_ANALYSIS_COMPETITORS } from "app/pages/sales-intelligence/constants/routes";
import CardFooter from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardFooter/CardFooter";
import CardHeader from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Card/CardHeader/CardHeader";
import { CardErrorBoundary } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/CardErrorBoundary/CardErrorBoundary";

import CompetitorsCard from "./CompetitorsCard";

const CompetitorsCardWithErrorBoundary = () => (
    <CardErrorBoundary
        dataAutomation="competitors-card"
        header={
            <CardHeader
                title={translate("si.company-analysis.competitors.card.header")}
                infoTooltip={translate("si.company-analysis.competitors.card.header.info-tooltip")}
            />
        }
        footer={<CardFooter stateId={COMPANY_ANALYSIS_COMPETITORS} />}
        width="50%"
    >
        <CompetitorsCard />
    </CardErrorBoundary>
);

export default CompetitorsCardWithErrorBoundary;
